var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{ref:"el",staticClass:"x-code",class:{ 'x-code--wrap': _vm.wrap }},[_c('prism',{style:(_vm.targetStyle),attrs:{"code":_vm.code,"inline":_vm.inline,"language":_vm.language}}),_c('CopyBtn',{staticClass:"mr-n3 mt-n3",attrs:{"target":_vm.target}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }